import { useAuth0 } from '@auth0/auth0-react';
import useMenuItems from './reactQuery/useMenuItems';
import getInitials from '../utils/getInitials';

// Who is signed in, for the sidebar and the Settings page. The name comes from the app's own
// user record (api/menu) when there is one, otherwise from the Auth0 profile.
export default function useProfile() {
  const { user } = useAuth0();
  const { data: menu } = useMenuItems();
  const record = menu?.user;

  const recordName = record
    ? `${record.firstName || ''} ${record.lastName || ''}`.trim()
    : '';
  const auth0Name =
    user?.name && !user.name.includes('@') ? user.name : user?.nickname;
  const name = recordName || auth0Name || user?.email || '';
  const email = record?.email || user?.email || '';

  return {
    name,
    email,
    role: record?.role || '',
    initials: getInitials(name, email),
  };
}
